<div [style.display]="sharedUrl? 'none' : 'initial'"
  #content>
  <ng-content></ng-content>
</div>